export default __webpack_public_path__ + "static/media/sh.0de30ebc.svg";